export default function () {
  return {
    availableMetrics: [],
    metricGroups: [],
    metricLoader: false,
    groupMetricLoader: false
  }
}
